import React from 'react';
import LegalContentLayout from '../components/common/Legal/LegalContentLayout';

const Cancel = () => <LegalContentLayout contentKey="terms" />;

export default Cancel;
